import { initKeyring } from './init-keyring';
import { launchStartupInitializations } from './launch-startup-initializations';

export async function initStartupFunctions() {
	await initKeyring();
	await launchStartupInitializations();
}
